import { FC, ReactNode } from 'react';

import { cn } from '../../../utils';

interface Props {
    readonly sidebar: ReactNode;
    readonly children: ReactNode;
    readonly className?: string;
}

export const DesktopFiltersLayout: FC<Props> = ({
    sidebar,
    children,
    className,
}) => {
    const hasSidebar =
        sidebar !== null && sidebar !== undefined && sidebar !== false;

    return (
        <div
            className={cn(
                hasSidebar &&
                    'lg:grid lg:grid-cols-4 lg:items-start lg:gap-4 xl:grid-cols-5 2xl:grid-cols-6',
                className,
            )}
            data-testid="desktop-filters-layout"
            data-has-sidebar={hasSidebar}
        >
            {hasSidebar && sidebar}
            <div
                className={cn(
                    'min-w-0',
                    hasSidebar && 'lg:col-span-3 xl:col-span-4 2xl:col-span-5',
                )}
                data-testid="desktop-filters-content"
            >
                {children}
            </div>
        </div>
    );
};
